import script from "./CancelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelPage.vue?vue&type=script&setup=true&lang=js"

import "./CancelPage.vue?vue&type=style&index=0&id=7b975a6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b975a6c"]])

export default __exports__